<section class="custom-modal" role="dialog" aria-modal="true" aria-labelledby="user-profile-modal-title">
  <header class="modal-header">
    <div class="modal-header-text">
      <h2 id="user-profile-modal-title" class="modal-title">Edit User Profile</h2>
      @if (userId) {
        <p class="modal-subtitle">{{ userId }}</p>
      }
    </div>
    <button type="button" class="icon-button" aria-label="Close" (click)="onCancel()">
      <app-display-icon [border]="false" [colour]="iconColourEnum.primary" [icon]="icons.close">
      </app-display-icon>
    </button>
  </header>

  <div class="modal-body">
    <div class="profile-hero">
      <button
        type="button"
        class="profile-avatar-button"
        aria-label="Change profile picture"
        (mouseenter)="isHoveringProfileImage.set(true)"
        (mouseleave)="isHoveringProfileImage.set(false)"
        (click)="onChangeProfilePictureClick()">
        @if (profileForm.get('pp')?.value) {
          @if (isHoveringProfileImage()) {
            <span class="profile-avatar-overlay">
              <app-display-icon
                [border]="false"
                [colour]="iconColourEnum.primary"
                [icon]="icons.cameraOutline">
              </app-display-icon>
            </span>
          }
          <img
            [src]="profileForm.get('pp')?.value"
            alt="Profile picture"
            class="profile-picture">
        } @else {
          <span class="initial-avatar">{{ profileInitials }}</span>
        }
      </button>
      <input
        id="userProfileConfigPictureInput"
        type="file"
        accept="image/*"
        hidden
        (change)="onProfilePictureChange($event)">

      <div class="profile-hero-meta">
        @if (userStatus) {
          <span
            class="status-badge"
            [class.status-badge-pending]="userStatus === 'PENDING'"
            [class.status-badge-verified]="userStatus === 'VERIFIED'"
            [class.status-badge-expired]="userStatus === 'EXPIRED'">
            {{ userStatus }}
          </span>
        }
        <p class="meta-text">{{ lastSeenDisplayText }}</p>
      </div>
    </div>

    <form [formGroup]="profileForm" class="profile-form" (ngSubmit)="onSubmit()">
      <p class="section-label">Account</p>
      <div class="form-grid">
        <div class="form-field form-field-full">
          <label class="form-label required" for="profile-username">Username</label>
          <input
            id="profile-username"
            class="form-input"
            formControlName="username"
            type="text"
            autocomplete="username"
            [class.form-input--error]="isFieldInvalid('username')"
            (blur)="onFieldBlur('username')">
          @if (isFieldInvalid('username')) {
            <span class="field-error">Username is required (3–30 characters)</span>
          }
        </div>
        <div class="form-field form-field-full">
          <label class="form-label" for="profile-email">Email Address</label>
          <input
            id="profile-email"
            class="form-input form-input--readonly"
            formControlName="email"
            type="email"
            autocomplete="email"
            readonly
            tabindex="-1"
            aria-readonly="true">
          <p class="hint-text">This email is linked to sign-in and cannot be changed here.</p>
        </div>
      </div>

      <p class="section-label">Personal Details</p>
      <div class="form-grid form-grid-split">
        <div class="form-field">
          <label class="form-label" for="profile-firstname">First Name</label>
          <input
            id="profile-firstname"
            class="form-input"
            formControlName="firstname"
            type="text"
            autocomplete="given-name"
            (blur)="onFieldBlur('firstname')">
        </div>
        <div class="form-field">
          <label class="form-label" for="profile-lastname">Last Name</label>
          <input
            id="profile-lastname"
            class="form-input"
            formControlName="lastname"
            type="text"
            autocomplete="family-name"
            (blur)="onFieldBlur('lastname')">
        </div>
      </div>

      <p class="section-label">Contact</p>
      <div class="form-grid">
        <div class="form-field form-field-full">
          <label class="form-label" for="profile-cellphone">Contact Number</label>
          <input
            id="profile-cellphone"
            class="form-input"
            formControlName="cellphone"
            type="tel"
            autocomplete="tel"
            [class.form-input--error]="isFieldInvalid('cellphone')"
            (blur)="onFieldBlur('cellphone')">
          @if (isFieldInvalid('cellphone')) {
            <span class="field-error">Please enter a valid contact number</span>
          }
        </div>
      </div>

      <p class="section-label">Security</p>
      <div class="security-row">
        <p class="security-hint">Send a password reset email to this user.</p>
        <app-shared-button [colour]="'secondary'" (click)="onResetPasswordClick()">
          Reset Password
        </app-shared-button>
      </div>
    </form>
  </div>

  <footer class="modal-footer">
    <app-shared-button [colour]="'primary'" [disabled]="isSaving()" (click)="onCancel()">
      Cancel
    </app-shared-button>
    <app-shared-button
      [colour]="'primary'"
      [disabled]="isSaveDisabled"
      [fill]="true"
      (buttonClicked)="onSubmit()">
      Save Changes
    </app-shared-button>
  </footer>
</section>
